import css from '../CTAButton.module.scss';
import classNames from 'classnames';
import { useLocalization } from '../../../../context/Localization/localization';
import { KioskCTAButtonDisplayProps } from './KioskCTAButtonDisplay.types';
import { ReactNode } from 'react';
import { GMRoundedIcon, GMSizedIcon } from '../../../Icon';

/**
 * The styling and display control for the Kiosk CTA Button.
 *
 * @param label - {@link KioskCTAButtonDisplayProps.label label} description.
 * @param inlineOptions - {@link KioskCTAButtonDisplayProps.inlineOptions inlineOptions} description.
 * @param squareOptions - {@link KioskCTAButtonDisplayProps.squareOptions squareOptions} description.
 * @param square - {@link KioskCTAButtonDisplayProps.square square} description.
 * @param hideIcon - {@link KioskCTAButtonDisplayProps.hideIcon hideIcon} description.
 * @param wider - {@link KioskCTAButtonDisplayProps.wider wider} description.
 * @param dataTestid - {@link KioskCTAButtonDisplayProps.dataTestid dataTestid} description.
 */
export const KioskCTAButtonDisplay = ({
    label,
    inlineOptions,
    squareOptions,
    square,
    hideIcon,
    wider,
    dataTestid,
}: KioskCTAButtonDisplayProps): ReactNode => {
    const Localization = useLocalization();

    return (
        <div
            className={classNames(css.kioskCTAButton, {
                [css.inline]: !square,
                [css.square]: square,
                [css.leftIcon]: inlineOptions?.leftIcon,
                [css.wider]: wider,
            })}
            data-testid={dataTestid}
            role={'presentation'}
        >
            <div className={css.label}>{label}</div>
            {!hideIcon && (
                <div className={css.icon} data-testid={!!dataTestid ? dataTestid + '-icon' : undefined}>
                    {square ? (
                        squareOptions?.roundedIcon ? (
                            squareOptions.roundedIcon
                        ) : (
                            <GMRoundedIcon
                                themeType={'primary'}
                                roundedBackgroundSize={'large'}
                                children={
                                    <GMSizedIcon
                                        iconSize={'custom'}
                                        iconType={'Complete'}
                                        ariaLabel={Localization.CompleteCheckmarkIcon}
                                    />
                                }
                            />
                        )
                    ) : null}
                    {!square ? (
                        inlineOptions?.sizedIcon ?
                            inlineOptions.sizedIcon :
                            <div className={css.arrowIcon}>
                                <GMSizedIcon
                                    iconSize={'medium'}
                                    iconType={'Arrow'}
                                    ariaLabel={Localization.ProceedArrow}
                                />
                            </div>
                    ) : null}
                </div>
            )}
        </div>
    );
};
